import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import HamburgerMenu from './HamburgerMenu';
import DesktopNavbar from './DesktopNavbar';

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isSmallScreen = viewportWidth < 1024;

  const goToExternalUrl = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleNavigateAndScroll = (pathname, sectionId) => {
    if (location.pathname !== pathname) navigate(pathname);
    requestAnimationFrame(() => {
      const headerHeight = document.getElementById('mainHeader')?.offsetHeight || 0;
      const target = document.getElementById(sectionId);
      if (target) {
        const extraOffset = 5;
        const elementTop = target.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: elementTop - headerHeight - extraOffset, behavior: 'smooth' });
      }
    });
  };

  return (
    <header id="mainHeader" className="relative z-[300] w-full bg-transparent p-4">
      {isSmallScreen ? (
        <div className="flex items-center justify-between">
          <img
            src="https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/CIPAheaderlogo.png"
            alt="Logo"
            className="h-16 w-auto"
            onClick={() => navigate('/')}
          />
          <HamburgerMenu
            navigate={navigate}
            handleNavigateAndScroll={handleNavigateAndScroll}
            goToExternalUrl={goToExternalUrl}
          />
        </div>
      ) : (
        /* full desktop layout */
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img
              src="https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/CIPAheaderlogo.png"
              alt="Logo"
              className="h-16 w-auto"
            />
          </div>

          {/* Desktop Navbar */}
          <div className="flex-1 mx-8">
            <DesktopNavbar
              navigate={navigate}
              handleNavigateAndScroll={handleNavigateAndScroll}
              goToExternalUrl={goToExternalUrl}
            />
          </div>

          {/* Action Buttons */}
          <div className="flex items-center space-x-4">
            {/* Phone icon with tooltip */}
            <div className="relative group">
              <a
                href="tel:+13096631011"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-black bg-white hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-black"
                aria-label="Call Central Illinois Pediatric Associates at (309) 663-1011"
              >
                {/* Inline SVG phone icon (black) */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-black"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l1.82-1.82a1 1 0 011.02-.24 11.36 11.36 0 003.56.57 1 1 0 011 1V20a1 1 0 01-1 1A16 16 0 014 5a1 1 0 011-1h2.11a1 1 0 011 1 11.36 11.36 0 00.57 3.56 1 1 0 01-.24 1.02l-1.82 1.82z" />
                </svg>
              </a>
              {/* Tooltip (below the icon) */}
<div className="pointer-events-none absolute left-1/2 top-full mt-2 -translate-x-1/2 whitespace-nowrap rounded-md bg-black px-2 py-1 text-xs font-medium text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100">
  (309) 663-1011
  {/* Arrow pointing up */}
  <div className="absolute left-1/2 -top-1 h-2 w-2 -translate-x-1/2 rotate-45 bg-black" />
</div>

            </div>

            <button
              className="border-2 border-black rounded-full px-4 py-2 font-semibold drop-shadow-md bg-custom-orange hover:bg-custom-darkOrange text-white"
              onClick={() =>
                goToExternalUrl(
                  'https://healow.com/apps/practice/central-il-pediatric-assoc-llc-bloomington-il-10568?v=2&locale=en'
                )
              }
            >
              Schedule Appointment
            </button>
            <button
              className="border-2 border-black rounded-full px-4 py-2 font-semibold drop-shadow-md bg-custom-green hover:bg-custom-darkGreen text-white"
              onClick={() =>
                goToExternalUrl('https://www.healowpay.com/HealowPay/jsp/healow/login.jsp')
              }
            >
              Bill Pay
            </button>
            <button
              className="border-2 border-black rounded-full px-4 py-2 font-semibold drop-shadow-md bg-custom-blue hover:bg-custom-darkBlue text-white"
              onClick={() =>
                goToExternalUrl('https://mycw65.ecwcloud.com/portal8399/jsp/100mp/login_otp.jsp')
              }
            >
              Patient Portal
            </button>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
